import { Trans, useTranslation } from 'react-i18next';
import { IBenefit } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import {
  IconCreditCard,
  IconReimbursement,
  Text,
} from '@coverflex-tech/hypernova';
import css from './ProductsStep.module.css';

interface IProps {
  benefit: IBenefit;
}

export const ProductsStep = ({ benefit }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={css.content}>
      {benefit.products.map((product) => {
        if (product.type === 'reimbursement') {
          return (
            <div key={product.type}>
              <div className={css.containerCard}>
                <IconReimbursement className={css.icon} />
                <Text bold>
                  {t(`learning_centre.${benefit.slug}.reimbursement.title`)}
                </Text>
              </div>
              <Text>
                <Trans>{`learning_centre.${benefit.slug}.reimbursement.description`}</Trans>
              </Text>
            </div>
          );
        }
        if (product.type === 'voucher_card') {
          return (
            <div key={product.type}>
              <div className={css.containerCard}>
                <IconCreditCard className={css.icon} />
                <Text bold>
                  {t(`learning_centre.${benefit.slug}.card.title`)}
                </Text>
              </div>
              <Text>
                <Trans>{`learning_centre.${benefit.slug}.card.description`}</Trans>
              </Text>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};
